@if (nodes.length > 0) {
  @for (node of nodes; track $index; let index = $index) {
    <app-checkbox-tree-node
      [level]="0"
      [index]="index"
      [treeId]="id"
      [node]="node"
      [config]="config"
      (nodeChanged)="onTreeChanged()"
    >
    </app-checkbox-tree-node>
  }
} @else {
  @if (emptyTreeNode) {
    <app-checkbox-tree-node [level]="0" [index]="0" [treeId]="id" [node]="emptyTreeNode" [config]="config">
    </app-checkbox-tree-node>
  }
}
